import { Model } from 'core/model';
import { omit } from 'lodash';
import { observable } from 'mobx';
import { defaultSerializer } from 'app/util/nms/serializations';
import InterfaceGroupModel from '../interfaceGroup/InterfaceGroupModel';

export default class MonitoringTemplateModel extends Model {
  @observable.ref
  interfaceGroup = new InterfaceGroupModel();

  get urlRoot() {
    return '/api/ui/recon/monitoringTemplates';
  }

  get omitDuringSerialize() {
    return ['simple', 'advanced', 'device_count', 'user_full_name', '_interfaceGroup', 'measurement'];
  }

  get isPreset() {
    return this.get('preset') > 0;
  }

  duplicate = (options = {}) => {
    const { isNew = false, save = false, deserialize = true } = options;
    const attributes = {
      ...omit(this.get(), ['id']),
      name: isNew ? '' : `Copy of ${this.get('name')}`,
      description: '',
      preset: 0
    };

    if (!this.collection) {
      return new this.constructor(attributes);
    }

    const dupe = this.collection.build(attributes, { deserialize });

    if (save) {
      dupe.save(attributes);
    }

    return dupe;
  };

  deserialize(data) {
    const { interface_group_id, settings } = data;
    const device_count = Number.parseInt(data.device_count) || 0;
    this.interfaceGroup.set('id', interface_group_id);
    const deserialized = {
      ...data,
      device_count,
      uiProperties: {
        polling: {
          snmp: {
            useDefaults: Boolean(!settings?.polling)
          }
        }
      }
    };
    return deserialized;
  }

  serialize(data) {
    const saveInterfaceGroup = !!data._interfaceGroup && (this.interfaceGroup.hasFilters || !this.interfaceGroup.isNew);
    const interfaceGroup = saveInterfaceGroup ? this.interfaceGroup.serialize(this.interfaceGroup.get()) : null;
    const template = { ...data, interfaceGroup };
    const { uiProperties } = data;

    // Omit polling settings if using NMS defaults
    if (uiProperties?.polling?.snmp?.useDefaults) {
      delete template.settings.polling;
    }

    // Remove uiProperties
    const serialized = defaultSerializer(template);

    return super.serialize(serialized);
  }
}
